<template>
  <v-dialog
    v-model="visible"
    width="30%"
    :fullscreen="$vuetify.breakpoint.smAndDown"
    persistent
    scrollable
    content-class="elevation-0"
  >
    <v-card class="rounded-xl">
      <v-card-title class="red white--text">
        {{ title }}
        <v-spacer></v-spacer>
        <v-btn icon class="white--text" @click="closeFalse()"><v-icon>close</v-icon></v-btn>
      </v-card-title>
      <v-divider></v-divider>
      <v-card-text class="pa-8 text-center subtitle-1">
        {{ message }}
      </v-card-text>
      <v-divider></v-divider>
      <v-card-actions class="mb-6 mb-md-0">
        <v-btn rounded text @click="closeFalse()">{{ abbrechen }}</v-btn>
        <v-spacer></v-spacer>
        <v-btn rounded class="red" @click="closeTrue()" dark text>{{ weiter }}</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
  export default {
    props: ['title', 'message', 'abbrechen', 'weiter', 'visible'],
    data () {
      return {
        loading: ''
      }
    },
    methods: {
      closeTrue () {
        this.$emit('closeTrue')
      },
      closeFalse () {
        this.$emit('closeFalse')
      }
    }
  }
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// dialogDelete.vue?4a1985f2